<template>
  <div v-bind:id="`widget-${widgetData.id}`"
       class="bto-base-widget">
    <component
      v-if="depricated.indexOf(widgetData.compiledProps.is) < 0"
      v-bind:is="widgetData.compiledProps.is"
      v-bind="widgetData.compiledProps">
    </component>
  </div>
</template>

<script>
  import { depricatedWidgets } from '../widgets/depricated-widgets';

  export default {
    name: 'ColWidgetComponent',
    data() {
      return {
        depricated: depricatedWidgets,
      };
    },
    props: {
      widgetData: {
        type: Object,
        required: true,
        default: () => {
        },
      },
    }
  };
</script>
